/*
 * File: EnrollStudentInPeriod.ts
 * Author: Austin Robinson
 * Date Created: 7/23/2023
 * Copyright (c) DrivingDoc 2023
 */

import { privateApi } from 'api';
import { createMutation } from "react-query-kit";

export type EnrollStudentInSectionParams = {
    courseSectionId: string;
    studentId: string;
}

export type EnrollStudentInSectionResult = object;


async function enrollStudentInSection(params: EnrollStudentInSectionParams): Promise<EnrollStudentInSectionResult> {
    // try {
    if (params === undefined) {
        return [];
    }

    // make api call
    const result = await privateApi.post(`${import.meta.env.VITE_API_BASE_URL}/courses/enrollStudentInSection`, params, {

    });

    if (result.status >= 400) {
        throw new Error(result.data.message);
    }

    // console.log(result.data);
    // return the data object
    return result.data;
    // } catch (e) {
    //     //     return [];
    // }
}

const useEnrollStudentInSection = createMutation({
    mutationFn: async (variables: EnrollStudentInSectionParams) => enrollStudentInSection(variables),
});

export { enrollStudentInSection, useEnrollStudentInSection };
